import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'src/shared/helpers/utils';

const badgeVariants = cva(
    'inline-flex items-center rounded-full px-2 py-[3px] min-h-6 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground hover:bg-primary/80',
                secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
                destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/80',
                outline: 'border text-foreground',
                'status-very-high': 'border text-status-very-high bg-status-very-high border-status-very-high',
                'status-high': 'border text-status-high bg-status-high border-status-high',
                'status-medium': 'border text-status-medium bg-status-medium border-status-medium',
                'status-low': 'border text-status-low bg-status-low border-status-low',
                'status-very-low': 'border text-status-very-low bg-status-very-low border-status-very-low',
                // Aliases of status-very-low/status-very-high for non-risk contexts (e.g. active/revoked states).
                success: 'border text-status-very-low bg-status-very-low border-status-very-low',
                error: 'border text-status-very-high bg-status-very-high border-status-very-high',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
